import React, { useEffect, useCallback, useState} from 'react';
import {freezeGroupByPatterns} from 'track/freeze/freezeGroupByPatterns.js';
import {connect} from 'react-redux';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

const GroupActions = ({group}) => { 
    let [toggled, setToggled] = useState(false);

    const freezeGroup = useCallback(() => {
        freezeGroupByPatterns(group);
    }, [group]);

    return (
        <div className="group-actions">
            <ButtonDropdown
              className="view-dropdown"
              show={toggled ? "true" : "false"}
              isOpen={toggled}
              toggle={() => setToggled(!toggled)}>
              <DropdownToggle size="sm" caret color="primary">
                <img className="group-actions-icon" src="/automation-icon-disabled.png"/>
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  onClick={freezeGroup}
                  key=""
                  size="sm">
                  Freeze Group
                </DropdownItem>
              </DropdownMenu>
            </ButtonDropdown>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GroupActions);
